import ApiConfig from "../../../config/api-config";
import { $apiClientForm } from "../../../utils/apiClient";

export function postNewGodo(payload) {
  return $apiClientForm.post(`${ApiConfig.NEWGODO}`,payload);
}
